import { useRecathModal } from "@/hooks/useRecathModal";
import { Box, Stack } from "@chakra-ui/react";
import {
  Button,
  ColorIcon,
  colors,
  getCdnImageSrc,
  HStack,
  Image,
  responsive,
  VStack,
} from "goi_common";
import React from "react";

export default function HeroSection() {
  const { openModal } = useRecathModal();

  return (
    <VStack
      width="100%"
      css={responsive({
        height: { base: "1000px", lg: "1100px" },
        padding: { base: "0 30px", lg: "0" },
      })}
      background={colors.black}
      position="relative"
      alignItems="center"
    >
      <VStack
        maxWidth={`${1200}px`}
        justifyContent="center"
        height="100%"
        width="100%"
        alignItems="center"
      >
        <Box className="gray400 subtitle_16_sb lg_head_28_sb">
          근조화환 / 근조기
        </Box>
        <Box
          className="white"
          css={responsive({
            fontSize: { base: 28, lg: 56 },
            fontWeight: { base: 700 },
            marginBottom: { base: 20, lg: 40 },
            letterSpacing: "-0.3px",
          })}
          zIndex={3}
          textAlign="center"
        >
          전국 최저가 근조화환 발주
          <br />
          모바일로 간편하고 신속하게
        </Box>
        <Box className="gray400 body_16_r lg_head_28_m" textAlign="center">
          모바일로 간단하게 발주하고, <br className="lg_over_hidden" /> 월
          결제로 정산은 더욱 쉽게
          <br /> 7만 원부터 발주 가능한 전국 최저가 근조화환
        </Box>
        <Button
          css={responsive({
            backgroundColor: colors.orange650,
            color: "white",
            padding: { base: "16px 28px", lg: "21px 52px" },
            marginTop: { base: 30, lg: 50 },
            fontSize: { base: 21, lg: 32 },
            fontWeight: { base: 700, lg: 700 },
            width: "fit-content",
            borderRadius: { base: "8px", lg: "10px" },
          })}
          onClick={openModal}
        >
          <HStack justifyContent="center" alignItems="center" gap="10px">
            <Box>도입 문의</Box>
            <ColorIcon name="headphone-mono" size={26} color={colors.white} />
          </HStack>
        </Button>

        <Stack
          css={responsive({
            flexDirection: { base: "column", lg: "row" },
            gap: { base: "10px", lg: "40px" },
            marginTop: { base: "20px", lg: "40px" },
          })}
          width="100%"
          alignItems="center"
          justifyContent="center"
        >
          <Image
            src={getCdnImageSrc("b2b/flower/flower-hero-3.png")}
            css={responsive({
              width: { base: "330px", lg: "500px" },
              marginTop: "8px",
            })}
          />
          <Image
            src={getCdnImageSrc("b2b/flower/flower-hero-2.png")}
            css={responsive({ width: { base: "330px", lg: "500px" } })}
          />
        </Stack>
      </VStack>
    </VStack>
  );
}
